import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedMaterialModule } from 'app/shared/shared-material.module';

import { FlexLayoutModule } from '@angular/flex-layout';

// import { CommonDirectivesModule } from './sdirectives/common/common-directives.module';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SigninComponent } from './signin/signin.component';
import { LoginComponent } from './signin/login/login.component';
import { RegisterComponent } from './signin/register/register.component';
import { RegisterConfirmationComponent } from './signin/register-confirmation/register-confirmation.component';
import { EmailVerificationComponent } from './signin/email-verification/email-verification.component';
import { SessionsRoutes } from './sessions.routing';
import { NotFoundComponent } from './not-found/not-found.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedMaterialModule,
    FlexLayoutModule,
    RouterModule.forChild(SessionsRoutes),
  ],
  declarations: [
    ForgotPasswordComponent,
    ResetPasswordComponent,
    SigninComponent,
    LoginComponent,
    RegisterComponent,
    RegisterConfirmationComponent,
    EmailVerificationComponent,
    NotFoundComponent,
  ],
})
export class SessionsModule {}
